import { ISimulationPrompt } from './isimulation-prompt';
import { ICallPersona } from './responses/ifetch-simulation-details';
import { ISectionsWithFacts } from './responses/ISectionsWithFacts';
import { IWordDefinition } from './responses/iword-definition';
import { IWords } from '../iwords';

export interface ISimulationDetail {
  tabSequence: number;
  tabTitle: string;
  tabText: string;
  uuid: string | null;
}

export interface ISimulationDetailsForm {
  simulationDetailtabs: ISimulationDetail[];
  additionalSectionTitle: string;
  additionalSectionInfo: string;
  additionalSectionUuid: string | null;
  /** Not populated by normalizeCallDetailsToForm (it's a top-level API field, not part of callDetails). */
  callDetailsAuthorOverride?: boolean;
}

export interface IGeneralFormGroup {
  simulationName: string;
  simulationInfo: string;
  simulationDescription: string;
  moduleUuid: string;
  moduleName: string;
  language: string;
  callPersona: ICallPersona;
  simulationDetailsInfo: ISimulationDetailsForm;
  screenshareEnabled: boolean;
}

export interface ISectionWeightForm {
  section: string;
  value: number;
  disabled: boolean;
}

export interface IAccuracyFeedbackForm {
  enabled: boolean;
  // server-owned: count of linked documents flagged for accuracy scoring
  documentCount: number;
}

export interface IKeywordsFormGroup {
  stt_words: IWordDefinition[]; // Array of word objects
  call_words: IWordDefinition[]; // Array of word objects
  replace_words: IWordDefinition[]; // Array of word objects
  pronounce_words?: IWordDefinition[];
  clean_transcript_words?: IWordDefinition[];
  // Store wordTypeUuid for each word type even when there are no words
  stt_words_wordTypeUuid?: string;
  call_words_wordTypeUuid?: string;
  replace_words_wordTypeUuid?: string;
  pronounce_words_wordTypeUuid?: string;
  clean_transcript_words_wordTypeUuid?: string;
  // Store hasProductScopedWords for each word type
  stt_words_hasProductScopedWords?: boolean;
  call_words_hasProductScopedWords?: boolean;
  replace_words_hasProductScopedWords?: boolean;
  pronounce_words_hasProductScopedWords?: boolean;
  clean_transcript_words_hasProductScopedWords?: boolean;
}

export enum KnowledgeCheckAnswerPointVerb {
  State = 'state',
  Mention = 'mention',
  Acknowledge = 'acknowledge',
}

export interface IKnowledgeCheckAnswerPoint {
  uuid?: string;
  verb: KnowledgeCheckAnswerPointVerb;
  displayText: string;
  displayFactIncorrect?: string | null;
  sequence?: number;
}

export interface IKnowledgeCheckQuestionForm {
  questionUuid: string;
  callGuidedUuid?: string;
  title: string | null;
  script: string;
  hint: string;
  resourceNote: string | null;
  sequence: number;
  answerPoints?: IKnowledgeCheckAnswerPoint[];
}

export interface ISimulationForm {
  updatedAt?: string;
  general: IGeneralFormGroup;
  content: {
    conversePrompt: ISimulationPrompt;
    cleanTranscriptPrompt: ISimulationPrompt;
    sttPrompt: ISimulationPrompt;
  };
  scoring: {
    overallScorePrompt: ISimulationPrompt;
    messagingPrompt: ISimulationPrompt;
    messagingThemes?: ISectionsWithFacts;
    methodologyPrompt: ISimulationPrompt;
    skillPrompt: ISimulationPrompt;
    sectionWeights: ISectionWeightForm[];
    accuracyFeedback: IAccuracyFeedbackForm;
  };
  keywords?: IKeywordsFormGroup;
  testing: {};
  questions?: IKnowledgeCheckQuestionForm[];
}
